import { poe1 } from "../game";
import { VERSION } from "../version";

const prefix = poe1 ? 'poe1' : 'poe';

export const LEAGUE_NAME = poe1 ? 'Curse of the Allflame' : 'Return of the Ancients';

// GGG item filter API limit for filter_name
export const MAX_FILTER_NAME_LENGTH = 40;

export const VALIDATE = true;
export const SYNC_WARNING_FOR_NEW_VERSION = false;

export const DISABLE_SYNC_UNTIL_REALM_DOWN = false;
export const FORCE_FIXED_ECO = false;

export const LOCAL_STORAGE_KEY_HIDE_COPIES_WARNING = `${prefix}-hide-copies-warning`;
export const LOCAL_STORAGE_KEY_FILTER_STORED = `${prefix}-filter-stored`;
export const LOCAL_STORAGE_KEY_FILTER_DEFAULT_REALM = `${prefix}-filter-default-realm`;
export const LOCAL_STORAGE_KEY_LAST_VERSION = `${prefix}-last-version`;
export const LOCAL_STORAGE_KEY_ACCESS_TOKEN = `${prefix}-access-token`;
export const LOCAL_STORAGE_KEY_SESSION_TOKEN = `${prefix}-session-token`;
export const LOCAL_STORAGE_KEY_USERNAME = `${prefix}-username`;
export const LOCAL_STORAGE_KEY_EXPIRATION_TIME = `${prefix}-expiration-time`;
export const LOCAL_STORAGE_KEY_DEFAULT_FILTER_ID = `${prefix}-default-filter-id`;
export const LOCAL_STORAGE_KEY_FILTERS = `${prefix}-filters`;
export const LOCAL_STORAGE_KEY_ACTIVE_FILTER_NAME = `${prefix}-active-filter-name`;
export const LOCAL_STORAGE_KEY_LAST_LOADED_FILTERS = `${prefix}-last-loaded-filters`;
export const LOCAL_STORAGE_KEY_ACCOUNT_FILTERS = `${prefix}-account-filters`;
export const LOCAL_STORAGE_KEY_REVISIT = `${prefix}-revisit`;
export const LOCAL_STORAGE_KEY_RESET_STORAGE = `${prefix}-reset-storage`;
export const LOCAL_STORAGE_KEY_CUSTOM_CURRENCY_TIERS = `${prefix}-custom-item-tiers`;
export const LOCAL_STORAGE_KEY_CUSTOM_GEAR_TIERS = `${prefix}-custom-gear-tiers`;
export const LOCAL_STORAGE_KEY_CUSTOM_UNIQUE_TIERS = `${prefix}-custom-unique-tiers`;
export const LOCAL_STORAGE_KEY_CUSTOM_CHANCE_BASE_TIERS = `${prefix}-custom-chance-base-tiers`;
export const LOCAL_STORAGE_KEY_TIERING_MODE = `${prefix}-tiering-mode`;
export const LOCAL_STORAGE_KEY_CURRENCY_TIER_LIST_SELECTION_MODE = `${prefix}-currency-tier-list-selection-mode`;
export const LOCAL_STORAGE_KEY_CURRENCY_TIER_LIST_CUSTOM_TYPES = `${prefix}-currency-tier-list-custom-types`;
export const LOCAL_STORAGE_KEY_RECENTLY_USED_COLORS = `${prefix}-recently-used-colors`;
export const LOCAL_STORAGE_KEY_STYLE_LIBRARY = `${prefix}-style-library`;
export const LOCAL_STORAGE_KEY_FORCE_FILTER_VALIDATION = `force-validation`;
export const LOCAL_STORAGE_KEY_FORCE_ALLOW_SYNC = `allow-sync`;

export const SESSION_STORAGE_KEY_FILTER_SNAPSHOT_CONSENT_PENDING = `${prefix}-filter-snapshot-consent-pending`;

export const URL_ECONOMY_DATA = poe1 ? "https://economy.poe1filter.com/" : "https://economy.poe2filter.com/"
export const FILE_NAME_CURRENCY = "v3/state-currency.json"
export const FILE_NAME_UNIQUES = "v3/state-uniques.json"
export const FILE_NAME_CLUSTER_JEWELS = "v3/state-cluster-jewels.json"

// Development mode flag for economy testing (only works in dev mode)
export const LOCAL_STORAGE_KEY_ECO_TESTING_MODE = `${prefix}-eco-testing-mode`;
export const SIMULATOR_DEBUG_MODE = false;

export { VERSION };
